import React, { memo, useEffect } from 'react';
import { Pagination } from 'react-bootstrap';
const PaginationItem = _ref => {
  let {
    number,
    isActive,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Pagination.Item, {
    key: number,
    active: isActive,
    onClick: onClick
  }, number);
};
export default PaginationItem;